import { type FC } from 'react';
import { Cell, type CellProps, type CheckboxProps, Switcher } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components';
import { StatefulTooltip, type StatefulTooltipProps } from '../../ui/StatefulTooltip';
import { SettingsBlockRow, type SettingsBlockRowProps } from './SettingsBlockRow';

export interface SettingsBlockRowCheckboxProps
    extends SettingsBlockRowProps,
        TestProps,
        Pick<CheckboxProps, 'aria-label'> {
    onChange: () => void;
    checkboxValue: boolean;
    isEditable?: boolean;
    checkboxTooltipProps?: Omit<StatefulTooltipProps, 'children'>;
    cellProps?: Omit<CellProps, 'align' | 'size' | 'type' | 'children'>;
}

export const SettingsBlockRowCheckbox: FC<SettingsBlockRowCheckboxProps> = ({
    'data-testid': dataTestId = 'SettingsBlockRow',
    'aria-label': ariaLabel = 'Чекбокс',
    checkboxValue,
    checkboxTooltipProps,
    cellProps = {},
    onChange,
    isEditable = true,
    ...props
}) => {
    const switcher = (
        <Switcher
            size="s"
            data-testid={dataTestId}
            isSelected={checkboxValue}
            onChange={onChange}
            aria-label={ariaLabel}
            isDisabled={!isEditable}
        />
    );

    return (
        <SettingsBlockRow {...props} data-testid={dataTestId}>
            <Cell align="left" size="m" type="Icon" {...cellProps}>
                {checkboxTooltipProps ? (
                    <StatefulTooltip {...checkboxTooltipProps}>{switcher}</StatefulTooltip>
                ) : (
                    switcher
                )}
            </Cell>
        </SettingsBlockRow>
    );
};
